import Head from "next/head";
import { Inter } from "next/font/google";
// import TopHeader from "@/components/TopHeader";
import Header from "@/components/Header";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const inter = Inter({
  subsets: ["latin"],
  weight: ["300", "400", "500", "600", "700", "800", "900"],
  variable: "--font-inter",
});

export default function ContactPage() {
  return (
    <div className={inter.variable}>
      <Head>
        <title>Contact Us - PISCESIA</title>
        <meta name="description" content="Get in touch with PISCESIA. Contact us for inquiries about our engineering services, projects, and corporate social responsibility initiatives." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      {/* <TopHeader /> */}
      <Header />
      <Contact />
      <Footer />
    </div>
  );
}
